import { useState, useEffect, useCallback } from 'react';
import apiService from '../services/api';

export interface HubOption {
  hubmasterid: number;
  hubname: string;
}

/** Full hub object as returned by GetAllHubs API */
export interface HubFull {
  hubmasterid: number;
  hubname: string;
  latitude?: number;
  longitude?: number;
  address1?: string;
  address2?: string;
  city?: number;
  state?: number;
  country?: number;
  zipcode?: string;
  status?: number;
  operationhours?: string;
  hubimage?: string;
  activeVehicleCount?: number;
  availableVehicleCount?: number;
  bookedVehicleCount?: number;
  underMaintenanceVehicleCount?: number;
  bannedVehicleCount?: number;
  totalvehiclesCount?: number;
  [key: string]: unknown;
}

const useHubs = (setError: (msg: string | null) => void) => {
  const [hubOptions, setHubOptions] = useState<HubOption[]>([]);
  const [hubs, setHubs] = useState<HubFull[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchHubs = useCallback(async () => {
    setLoading(true);
    try {
      const response = (await apiService.getAllHubs()) as any;
      
      let transformedHubs: HubFull[] = [];
      const responseData = response?.data || response;
      
      if (Array.isArray(responseData)) {
        transformedHubs = responseData;
      } else if (responseData && typeof responseData === 'object') {
        if (Array.isArray(responseData.hubs)) {
          transformedHubs = responseData.hubs;
        } else if (Array.isArray(responseData.result)) {
          transformedHubs = responseData.result;
        }
      }
      
      const hubData = transformedHubs.map((hub: any) => ({
        hubmasterid: hub.hubmasterid || hub.hubid || hub.id,
        hubname: hub.hubname || hub.hubName || hub.name || `Hub ${hub.hubmasterid || hub.hubid || hub.id}`
      })).filter((hub: { hubmasterid: unknown; hubname: string }) => hub.hubmasterid && hub.hubname);
      
      setHubOptions(hubData);
      setHubs(transformedHubs);
    } catch (error) {
      console.error("Error fetching hubs:", error);
      setError("Failed to load hub options. Please refresh the page.");
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => {
    fetchHubs();
  }, [fetchHubs]);

  return { hubOptions, hubs, loading };
};

export default useHubs;
